export default "__VITE_ASSET__DlchN58g__"